import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';

import Layout from 'containers/Layout';

import * as Dashboard from 'pages/Dashboard';
import * as KnowledgeBase from 'pages/KnowledgeBase';
import * as Search from 'pages/Search';
import * as Customer from 'pages/Customer';
import * as Person from 'pages/Person';
import * as Appeal from 'pages/Appeal';
import * as Appeals from 'pages/Appeals';
import * as Settings from 'pages/Settings';
import * as AdvancedSearch from 'pages/AdvancedSearch';
import * as AdvancedReport from 'pages/AdvancedReport';
import * as Learning from 'pages/Learning';
import * as PersonalCabinet from 'pages/PersonalCabinet';
import * as OvvCabinet from 'pages/OvvCabinet';
import VideoCall from 'pages/VideoCall';
import Corezoid from 'pages/Corezoid';
import SenderAdmin from 'pages/SenderAdmin';

const PersonalCabinetSettings = React.lazy(() => import('pages/PersonalCabinet/Settings'));
const OvvCabinetSettings = React.lazy(() => import('pages/OvvCabinet/Settings'));
const AdvancedReportDashboard = React.lazy(() => import('pages/AdvancedReport/Dashboard'));
const AdvancedReportTemplates = React.lazy(() => import('pages/AdvancedReport/Templates'));
const AdvancedReportBuilder = React.lazy(() => import('pages/AdvancedReport/Builder'));
const AdvancedReportCartogram = React.lazy(() => import('pages/AdvancedReport/Cartogram'));

const AppRouter = ({ children }) => {
	return (
		<HashRouter>
			<Layout>
				<Switch>
					<Route exact path="/">
						<Redirect to={Appeal.routes.base} />
					</Route>

					<Route path={Appeal.routes.base} component={Appeal.default} />
					<Route path={Search.routes.base} component={Search.default} />
					<Route path={Appeals.routes.base} component={Appeals.default} />
					<Route path={Customer.routes.base} component={Customer.default} />
					<Route path={Person.routes.base} component={Person.default} />
					<Route path={KnowledgeBase.routes.base} component={KnowledgeBase.default} />
					<Route path={Dashboard.routes.base} component={Dashboard.default} />
					<Route path={Settings.routes.base} component={Settings.default} />
					<Route path={AdvancedSearch.routes.base} component={AdvancedSearch.default} />
					<Route
						path={[
							PersonalCabinet.routes.base,
							PersonalCabinet.routes.knowledgeBase,
							PersonalCabinet.routes.knowledgeBase__article,
							PersonalCabinet.routes.knowledgeBase__theme,
							PersonalCabinet.routes.learning,
							PersonalCabinet.routes.learning__tab,
							PersonalCabinet.routes.notifications,
							PersonalCabinet.routes.notifications__item,
						]}
						exact
						component={PersonalCabinet.default}
					/>
					<Route path="/personal-cabinet/settings" component={PersonalCabinetSettings} />
					<Route
						path={[
							OvvCabinet.routes.base,
							OvvCabinet.routes.notifications,
							OvvCabinet.routes.notifications__item,
						]}
						exact
						component={OvvCabinet.default}
					/>
					<Route path={OvvCabinet.routes.settings} component={OvvCabinetSettings} />

					<Route path={AdvancedReport.routes.base}>
						<AdvancedReport.default>
							<Switch>
								<Route
									exact
									path={AdvancedReport.routes.dashboard}
									component={AdvancedReportDashboard}
								/>

								<Route path={AdvancedReport.routes.templates} component={AdvancedReportTemplates} />

								<Route
									path={[
										AdvancedReport.routes.builder,
										AdvancedReport.routes.builder__section,
									]}
									component={AdvancedReportBuilder}
								/>

								<Route
									path={[
										AdvancedReport.routes.cartograms,
										AdvancedReport.routes.cartograms__section,
									]}
									component={AdvancedReportCartogram}
								/>
							</Switch>
						</AdvancedReport.default>
					</Route>

					<Route path={Learning.routes.base}>
						<Route
							exact
							path={[
								Learning.routes.base,
								Learning.routes.course,
								Learning.routes.course__tab,
							]}
							component={Learning.default}
						/>

						<Route
							path={[
								Learning.routes.course__quiz__review,
							]}
							component={Learning.QuizReview}
						/>

						<Route
							path={[
								Learning.routes.course__quiz__edit,
							]}
							component={Learning.QuizEdit}
						/>

						<Route
							path={[
								Learning.routes.course__task,
							]}
							component={Learning.Task}
						/>
					</Route>
				</Switch>

				<Suspense fallback={null}>
					<VideoCall />
					<Corezoid />
					<SenderAdmin />
				</Suspense>

				{children}
			</Layout>
		</HashRouter>
	);
};

AppRouter.propTypes = {
	children: PropTypes.node,
};

export default AppRouter;
